export class EnumApiCompany {
    constructor() {
        /**
         * @dec post 企业认证 - token 获取企业认证信息
         */
        this.company_auth_token = {
            url: '/api/gateway/company-cert-bff/api/partnerVerified/token',
            method: 'post',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec post 企业认证 - 企业认证提交
         */
        this.company_auth_certification = {
            url: '/api/gateway/company-cert-bff/api/partnerVerified/certification',
            method: 'post',
        };
        /**
         * @dec post 营业执照识别
         */
        this.company_ocr_busLicense = {
            url: '/api/gateway/company-cert-bff/ocr/api/busLicense',
            method: 'post',
        };
        /**
         * @dec post 身份证识别
         */
        this.company_ocr_idCard = {
            url: '/api/gateway/company-cert-bff/ocr/api/idCard/front',
            method: 'post',
        };
        /**
         * @dec
         * @method post 查询企业是否认证
         * @params
         */
        this.partner_search_Company = {
            url: '/api/gateway/company-cert-bff/api/partnerVerified/findCompanyIsCert',
            method: 'post',
        };
    }
}
